import { useSelector, useDispatch } from "react-redux";
import { useBooleanFlagValue } from "@openfeature/react-sdk";
import { selectActiveTopicHRefSearchPath } from "../features/counter/counterSlice";
import updateActiveTopicHrefSearchPath from "../features/counter/updateActiveTopicHrefSearchPath";
import flags from "../features/featureFlags/flags";

const useActiveTopicBrowserHistory = () => {
    const dispatch = useDispatch();
    const activeTopicHRefSearchPath = useSelector(
        selectActiveTopicHRefSearchPath,
    );

    const isEnhancedBrowserHistoryButton = useBooleanFlagValue(
        flags.ENHANCED_BROWSER_HISTORY_BUTTON,
        false,
    );

    const updateBrowserHistoryOfActiveTopic = ({ msPath, hrefPath, header }) => {
        updateActiveTopicHrefSearchPath({
            dispatch,
            isEnhancedBrowserHistoryButton,
            activeTopicHRefSearchPath,
            mpsPathJS: msPath,
            selectedHref: hrefPath,
            header,
        });

    }
    return { updateBrowserHistoryOfActiveTopic };
}


export default useActiveTopicBrowserHistory